<template>
  <div>
    <div>
      <p><b>File Name</b></p>
      <input v-model="new_file_name" class="outlined full_width" placeholder="שם קובץ.pdf">
    </div>
    <div class="vertical_space"></div>
    <div v-if="!file_helper.isAuthorized(new_file_name)">
      <p class="m-0"><b>אנא תקנ/י את השגיאות הבאות:</b></p>
      <p class="m-0" v-for="file_error in file_errors" :key="file_error">תו לא מקובל - "<b>{{ file_error }}</b>"</p>
    </div>
    <div class="modal_footer">
      <a
        @click="submit()"
        :class="{ 'is-loading': is_loading, faded: !file_helper.isAuthorized(new_file_name) }"
        class="button is-info"
        >Submit</a
      >
    </div>
  </div>
</template>
<script>
import { mapMutations } from 'vuex'
import FileHelper from '@/custom/classes/file_helper.js'
export default {
  name: 'file-editor',
  props: ['payload'],
  data () {
    return {
      is_loading: false,
      file_helper: new FileHelper(),
      new_file_name: this.payload.file.name,
      file_errors: ''
    }
  },
  watch: {
    new_file_name () {
      this.file_errors = this.file_helper.getErrors(this.new_file_name)
    }
  },
  methods: {
    submit () {
      let params = {}

      if (this.payload.is_contract) {
        params = {
          is_contract: true,
          file_name: this.payload.file.name,
          new_file_name: this.new_file_name,
          env_id: this.payload.env_id,
          env: this.payload.env
        }
      } else {
        params = {
          file_name: this.payload.file.name,
          new_file_name: this.new_file_name,
          resource_id: this.payload.applicant.resource_id,
          resource_type: 'Applicant',
          first_name: this.payload.applicant.first_name,
          last_name: this.payload.applicant.last_name,
          show_archive: this.payload.is_archive
        }
      }
      this.is_loading = true
      this.$network_utils.updateFile(params).then(() => {
        this.is_loading = false
        if (this.payload.refresh) {
          this.payload.refresh()
        }
        this.$utils.emit('show_toast', { text: 'הקובץ עודכן' })
        this.remove(this.payload)
      })
    },
    ...mapMutations('modals', ['remove'])
  }
}
</script>
